<template>
  <v-card>
    <EditCustomerDialog ref="editDialog" />

    <v-toolbar class="card-bar">
      <v-toolbar-title>{{ customer.label }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="startEdit">
        <v-icon>edit</v-icon>
      </v-btn>
      <OMenuButton :menuOpts="menuOpts" />
    </v-toolbar>

    <v-card-text>
      <div v-if="customer.deletedAt != null" class="tag red mb-4">
        Desativado em {{ customer.deletedAt | moment('DD/MMM/YYYY HH:mm') }}
      </div>

      <OCapCont
        label="Segmento"
        class="oderon-col-12 mb-4"
        :value="customer.marketSegment"
      />

      <OCapCont
        label="Classificação"
        class="oderon-col-12 mb-4"
        :value="customer.classification"
      />

      <div class="cap-cont oderon-col-12 mb-4">
        <label>Observações</label>
        <p style="white-space: pre-line">{{ customer.comments || '─' }}</p>
      </div>

      <div class="cap-cont oderon-col-12 mb-4">
        <label>Produtos Contratados</label>
        <p style="white-space: pre-line">{{ customer.productsDesc || '─' }}</p>
      </div>

      <div class="mb-4">
        <label class="light-caption">Documentos</label>
        <p class="big-content" v-if="customer.links.length == 0">─</p>
        <v-btn
          v-for="(link, idx) in customer.links"
          :key="idx"
          :href="link.url"
          target="_blank"
          small
          class="mr-2"
        >
          {{ link.text }}
          <v-icon small right>mdi-open-in-new</v-icon>
        </v-btn>
      </div>

      <OCapCont
        label="Criado em"
        :value="customer.createdAt | moment('DD/MMM/YYYY HH:mm')"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import EditCustomerDialog from './EditCustomerDialog.vue'
import { Customer } from '@/models'
import Store from './Store'

export default {
  components: { EditCustomerDialog },
  computed: {
    customer() {
      return Store.row
    },
    menuOpts() {
      return [
        {
          text: 'Desativar...',
          icon: 'mdi-cancel',
          disabled: this.customer.deletedAt != null,
          onClick: () => this.confirmDeactivate()
        },
        {
          text: 'Reativar...',
          icon: 'mdi-restore',
          disabled: this.customer.deletedAt == null,
          onClick: () => this.confirmReactivate()
        }
      ]
    }
  },
  methods: {
    async confirmDeactivate() {
      const proceed = await this.$confirm({
        verb: 'desativar',
        strings: 'cliente;o'
      })

      if (proceed) {
        await this.$loading(async () => {
          await Customer.delete(this.customer.id)
          await Store.reload()
          this.$snack('Desativado com sucesso')
        })
      }
    },

    async confirmReactivate() {
      const proceed = await this.$confirm({
        verb: 'reativar',
        strings: 'cliente;o'
      })

      if (proceed) {
        await this.$loading(async () => {
          await Customer.reactivate(this.customer.id)
          await Store.reload()
          this.$snack('Reativado com sucesso')
        })
      }
    },

    async startEdit() {
      const res = await this.$refs.editDialog.open(this.customer.id)
      if (res != null) {
        this.$loading(async () => {
          await Customer.save(res)
          await Store.reload()
          this.$snack('Salvo com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
